import axiosInstance from "../services/axiosInstance";

export const ApprovalsOvertimeRequest = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/overtime/approvals",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
